import * as React from 'react';
import { MonografiaModel } from '../../../Store';
import {
  CardTitle,
  Input,
  CardContent,
  Card,
  Button,
  withGrid
} from '../../../Components';
import { format } from 'date-fns';
import styled from 'styled-components';
import { media } from '../../../Themes';
import { CurrentUserModel } from '../../../Store/Auth';

/*
  interfaces
*/
interface IProps {
  monografia: MonografiaModel;
  currentUser: CurrentUserModel;
  aceitarConvite: () => void;
  rejeitarConvite: () => void;
}

/*
  styled components
*/
const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;
const Grid = withGrid(CardContent);

const AgendamentoContent = styled(Grid)`
  grid-template-columns: repeat(12fr, 1fr);
  justify-content: none;
`;
const StyledButton = styled(Button)``;

const Actions = styled.div`
  grid-column: 11/13;
  display: flex;
  justify-content: space-around;
`;

/*
  Component: InformacoesAgendamento
*/
export class InformacoesAgendamento extends React.Component<
  IProps
  > {
  render() {
    const { monografia, currentUser } = this.props;
    const conviteAtual = monografia.banca.filter(c => c.membro.cpf === currentUser.cpf)[0];

    return (
      <Card>
        <CardTitle>Agendamento</CardTitle>
        <AgendamentoContent>
          {monografia.agendamento && monografia.agendamento.dataInicio ? (
            <>
              <InputGrid
                gridColumn='1/4'
                disabled={true}
                label={'Data de agendamento'}
                value={format(
                  monografia.agendamento.dataInicio,
                  'DD/MM/YYYY'
                )}
              />
              <InputGrid
                gridColumn='4/8'
                disabled={true}
                label={'Horario de agendamento'}
                value={format(
                  monografia.agendamento.dataInicio,
                  'HH:mm'
                )}
              />
              <InputGrid
                gridColumn='8/13'
                disabled={true}
                label={'Local do agendamento'}
                value={monografia.agendamento.local}
              />
            </>
          ) :
            <InputGrid
              gridColumn='1/5'
              disabled={true}
              label={'Data sugerida pelo orientador'}
              value={format(
                monografia.dataDeApresentacaoSugerida!,
                'DD/MM/YYYY HH:mm'
              )}
            />
          }
          <Actions>
            <StyledButton
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_API_URL}arquivo/${
                  monografia.deposito!.identifier
                  }`
                )
              }
            >
              Baixar TCC
            </StyledButton>
            <StyledButton
              color={'errorColor'}
              onClick={this.props.rejeitarConvite}
              disabled={conviteAtual && conviteAtual.conviteAceito != undefined}
            >
              Recusar
            </StyledButton>
            <StyledButton
              color={'approvedColor'}
              onClick={this.props.aceitarConvite}
              disabled={conviteAtual && conviteAtual.conviteAceito != undefined}
            >
              Aceitar
            </StyledButton>
          </Actions>
        </AgendamentoContent>
      </Card>
    );
  }
}
